import * as ActionTypes from '../constants/actions';

export function show(from, to, avoid = [], options = {}) {
    return {
        type: ActionTypes.MAP_SHOW,
        payload: {
            from,
            to,
            avoid,
            options
        }
    }
}

export function hide() {
    return {
        type: ActionTypes.MAP_HIDE,
        payload: {}
    }
}

export function setPoint(id, type) {
    return {
        type: ActionTypes.MAP_SET_POINT,
        payload: {
            id,
            type
        }
    }
}

export function changeAccessibility(value) {
    return {
        type: ActionTypes.MAP_CHANGE_ACCESSIBILITY,
        payload: {
            value
        }
    }
}

export function changeFloor(floor) {
    return {
        type: ActionTypes.MAP_CHANGE_FLOOR,
        payload: {
            floor
        }
    }
}


// WEBPACK FOOTER //
// ./actions/map.js